import type React from 'react';
import { EnumHelperBase, LANGUAGE, languageEnumBase, type LanguageEnumBaseData, type LanguageEnumBaseExtraData } from '@nfctron/nexus-core';
import {
	AmericaFlagIcon,
	CzechiaFlagIcon,
	FranceFlagIcon,
	GermanyFlagIcon,
	NorwayFlagIcon,
	RussiaFlagIcon,
	SlovakiaFlagIcon,
	SpainFlagIcon,
	SwedenFlagIcon,
} from '@nfctron/nexus-react-svg';

export interface LanguageEnumReactExtraDataExtend {
	Icon: React.FC<React.SVGProps<SVGElement>>;
	emojiFlag: string;
}

export interface LanguageEnumReactData extends LanguageEnumBaseData, LanguageEnumReactExtraDataExtend {}

/**
 * Language enumeration with extra data for React
 * @extends LanguageEnumBase Base language enumeration
 */
class LanguageEnumReact extends EnumHelperBase<
	LanguageEnumBaseExtraData,
	LANGUAGE,
	typeof languageEnumBase.enumName,
	typeof languageEnumBase.idKey,
	LanguageEnumReactExtraDataExtend
> {
	constructor() {
		super(languageEnumBase.enumName, languageEnumBase.data, languageEnumBase.idKey, {
			[LANGUAGE.CZECH]: { Icon: CzechiaFlagIcon, emojiFlag: '🇨🇿' },
			[LANGUAGE.ENGLISH]: { Icon: AmericaFlagIcon, emojiFlag: '🇺🇸' },
			[LANGUAGE.SLOVAK]: { Icon: SlovakiaFlagIcon, emojiFlag: '🇸🇰' },
			[LANGUAGE.GERMAN]: { Icon: GermanyFlagIcon, emojiFlag: '🇩🇪' },
			[LANGUAGE.FRENCH]: { Icon: FranceFlagIcon, emojiFlag: '🇫🇷' },
			[LANGUAGE.SPANISH]: { Icon: SpainFlagIcon, emojiFlag: '🇪🇸' },
			[LANGUAGE.RUSSIAN]: { Icon: RussiaFlagIcon, emojiFlag: '🇷🇺' },
			[LANGUAGE.NORWEGIAN]: { Icon: NorwayFlagIcon, emojiFlag: '🇳🇴' },
			[LANGUAGE.SWEDISH]: { Icon: SwedenFlagIcon, emojiFlag: '🇸🇪' },
		});
	}
}

export const languageEnumReact = new LanguageEnumReact();
